<template lang='pug'>
.campaign-list(v-loading="loading")
  el-breadcrumb(
    separator="/"
    style="padding-bottom: 20px"
  )
    el-breadcrumb-item {{ $t('项目列表') }}
  .campaign-list__header
    .campaign-list__header__buttons
      el-button(
        class="addNewProject__btn"
        v-if="isView"
        plain
        @click='addNewCampaign',
      )
        i(style="margin-right: 5px").iconfont.icon-wujiaoxing
        span {{ $t('新建全流程项目') }}
      el-button(
        class="addNewLiteProject__btn"
        v-if="showAddLiteButton"
        plain
        @click='addNewShortcutCampaign',
      )
        i(style="margin-right: 5px").iconfont.icon-shandian
        span {{ $t('新建快捷项目') }}
    .campaign-list__header__filter
      i(
        v-if="isFilterCollapse"
        @click="isFilterCollapse = false"
      ).iconfont.icon-shaixuanxian
      i(
        v-else
        @click="isFilterCollapse = true"
      ).iconfont.icon-shaixuanmian

      el-input(
        :placeholder="$t('搜索项目名称/ID')"
        v-model="currentKeyword"
        @keyup.enter.native="handleSearch"
      )
        i(
          v-show="currentKeyword !== ''"
          slot="suffix"
          class="el-input__icon el-icon-circle-close"
          style="cursor: pointer"
          @click="handleClearInput"
        )
        i(
          slot="suffix"
          class="el-input__icon el-icon-search"
          style="cursor: pointer"
          @click="handleSearch"
        )

  filter-panel(
    v-if="!isFilterCollapse"
    @changeBrand="changeBrand"
    @changeVendor="changeVendor"
    @clear="clear"
  )

  el-table.campaign-list__table(
    :data='campaignList',
  )
    el-table-column(
      prop='campaign_id',
      :label='$t("项目ID")',
      align='left'
      min-width="95"
    )
    el-table-column(
      prop='campaign_name',
      :label='$t("项目名称")',
      align='left',
      min-width="130"
      show-overflow-tooltip,
    )
    el-table-column(
      :label='$t("项目类型")',
      align='left'
      min-width="115"
    )
      template(slot-scope="scope")
        div(
          v-if="scope.row.campaign_type === 0"
          :style="{ display: 'flex', alignItems: 'center' }"
        )
          i.iconfont.icon-wujiaoxing(
            :style="{ color: '#4896e6', marginRight: '5px' }"
          )
          span {{ $t('全流程') }}
        div(
          v-if="scope.row.campaign_type === 1"
          :style="{ display: 'flex', alignItems: 'center' }"
        )
          i.iconfont.icon-shandian(
            :style="{ color: '#5bd5ac', marginRight: '5px' }"
          )
          span {{ $t('快捷') }}
    el-table-column(
      prop='brand_name',
      :label='$t("品牌")',
      align='left',
      show-tooltip-when-overflow
    )
    el-table-column(
      prop='budget',
      :label='$t("预算")',
      align='left',
      min-width="110"
      show-tooltip-when-overflow
      :formatter="(row) => formatMoney(row.budget)"
    )
    el-table-column(
      :label='$t("上线时间")',
      align='left',
      style="text-align: left"
      min-width="115"
    )
      template(slot-scope="scope")
        span {{ scope.row.start_date | formatDate }} ~
        br
        span {{ scope.row.end_date | formatDate  }}
    el-table-column(
      :label='$t("进度")',
      align='left',
      :min-width="isEn && '165'"
    )
      template(slot-scope="scope")
        span {{ scope.row.phase == null ? '—' : $t(scope.row.phase_zh)}}
    el-table-column(
      :label='$t("操作")',
      align='left',
      min-width="160"
    )
      template(slot-scope='scope')
        .campaign-list__operation
          el-button(
            @click='getParams(scope.row)',
          ) {{ $t('查看') }}
          //- el-button(
          //-   :disabled="!scope.row.can_delete",
          //-   @click='onDelete(scope.row.campaign_id)'
          //- ) {{ $t('删除') }}
  el-pagination.campaign-list__pagination(
    layout='prev, pager, next, jumper',
    :page-size='10',
    :total='total',
    :current-page.sync='currentPage',
    @current-change='fetchCampaignList',
  )
</template>

<script>
import axios from 'axios'
import { format4backend, formatMoney, formatDate } from '@/umcc/util'
import db from '@/umcc/db'
import SearchInputWithDelete from '@/components/SearchInputWithDelete'
import FilterPanel from './components/FilterPanel'

export default {
  components: {
    SearchInputWithDelete,
    FilterPanel
  },
  data () {
    return {
      campaignList: null,
      loading: false,
      currentPage: 1,
      total: null,
      currentKeyword: '',
      businessType: null,
      phase: null,
      phaseType: null,
      isFilterCollapse: true,
      selectedBrand: null,
      selectedVendor: null
    }
  },
  watch: {
    $route () {
      this.$store.commit('campaign/setCampaignListPageNumber', 1)
      this.$store.commit('campaign/setCampaignListKeyword', '')
      this.$store.commit('campaign/setCampaignListBrandId', null)
      this.$store.commit('campaign/setCampaignListVendorId', null)
      this.currentKeyword = ''
      this.currentPage = 1
      this.selectedVendor = null
      this.selectedBrand = null
      this.fetchCampaignList()
    }
  },
  mounted () {
    this.currentKeyword = this.keyword
    this.selectedVendor = this.vendorId
    this.selectedBrand = this.brandId
    this.currentPage = this.pageNumber
    this.isFilterCollapse = this.brandId == null && this.vendorId == null
    this.fetchCampaignList()
  },
  filters: {
    formatDate
  },
  computed: {
    isView () {
      return this.$store.state.common.user.permissions.includes('Management_Campaign_C')
    },
    showAddLiteButton () {
      return this.$store.state.common.user.permissions.includes('Management_Lite_Campaign_C')
    },
    isEn () {
      return db.lang === 'en'
    },
    keyword () {
      return this.$store.state.campaign.campaignListKeyword
    },
    pageNumber () {
      return this.$store.state.campaign.campaignListPageNumber
    },
    brandId () {
      return this.$store.state.campaign.campaignListBrandId
    },
    vendorId () {
      return this.$store.state.campaign.campaignListVendorId
    },
    version () {
      return this.$store.state.campaign.campaignVersion
    }
  },
  methods: {
    fetchCampaignList () {
      this.$store.commit('campaign/setCampaignListPageNumber', this.currentPage)
      this.$store.commit('campaign/setCampaignListKeyword', this.currentKeyword)
      this.$store.commit('campaign/setCampaignListBrandId', this.selectedBrand)
      this.$store.commit('campaign/setCampaignListVendorId', this.selectedVendor)
      this.loading = true
      let params = {
        page_number: this.currentPage,
        page_size: 10,
        keyword: this.currentKeyword,
        brand_id: this.brandId,
        vendor_id: this.vendorId
      }
      axios
        .get('/management/campaign/getCampaignList', {
          params
        })
        .then((res) => {
          this.campaignList = res.table_data
          this.total = res.total_row
          this.loading = false
        })
    },
    formatMoney: formatMoney,
    getParams (row) {
      this.loading = true
      this.$store.commit('campaign/setCampaignVersion', row.version)
      axios
        .get('/management/subfinal/getSubFinalScopeList', {
          params: {
            campaign_id: row.campaign_id
          }
        })
        .then((res) => {
          this.businessType = row.business_type
          this.phaseType = row.phase_type
          if ((row.version && row.version > 'v2' && row.phase_type === 2) || row.phase_type === 3 || row.phase_type === 4) {
            this.$store.commit('campaign/setSubFinalScopeId', res[0].sub_final_scope_id)
          }
          this.view(row)
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    canViewProcess (id) {
      return axios
        .get('/management/subfinal/canViewProcess', {
          params: {
            campaign_id: id
          }
        })
    },
    getDotProcess (id) {
      return axios.get('/management/subfinal/getDotProcess', {
        params: {
          campaign_id: id
        }
      })
    },
    async view (row) {
      if (row.campaign_type === 0) {
        this.$store.dispatch('campaign/update', row.campaign_id)
        this.$store.commit('campaign/setCampaignName', row.campaign_name)
        this.$store.commit('campaign/setPhaseType', this.phaseType)
        this.$store.commit('campaign/setIsNewBrief', row.is_new_brief)
        this.$store.commit('campaign/setBusinessType', this.businessType)
        this.$store.commit('campaign/setOriginalBusinessType', this.businessType)
        const [res, dot] = await Promise.all([
          this.canViewProcess(row.campaign_id),
          this.getDotProcess(row.campaign_id)
        ])
        this.loading = false
        if (res.can_view) {
          this.$store.commit('campaign/setIsBypassCampaign', row.is_bypass === 1)
          this.$router.push('/campaign/process')
        } else {
          this.$store.commit('campaign/setSubFinalScopeId', dot.sub_final_scope_id)
          this.$store.commit('campaign/setDotPhaseType', dot.phase_type)
          this.$store.commit('campaign/setDotBusinessType', dot.business_type)
          this.$store.commit('campaign/setDotSubFinalScopeId', dot.sub_final_scope_id)
          this.$router.push('/campaign/dot/social-tracking')
        }
      } else {
        const [res, dot] = await Promise.all([
          this.canViewProcess(row.campaign_id),
          this.getDotProcess(row.campaign_id)
        ])
        this.loading = false
        this.$store.dispatch('campaign/update', row.campaign_id)
        if (res.can_view) {
          this.$router.push('/campaign/edit-shortcut')
        } else {
          this.$store.commit('campaign/setDotPhaseType', dot.phase_type)
          this.$store.commit('campaign/setDotBusinessType', dot.business_type)
          this.$store.commit('campaign/setDotSubFinalScopeId', dot.sub_final_scope_id)
          this.$store.commit('campaign/setSubFinalScopeId', dot.sub_final_scope_id)
          this.$router.push('/shortcut/dot/social-tracking')
        }
      }
    },
    onDelete (id) {
      this.$confirm(this.$t('项目删除后，不可恢复'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          const params = { campaign_id: id }
          axios
            .post('/management/campaign/delete', format4backend(params))
            .then((res) => {
              this.$message.success(this.$t('删除项目成功！'))
              this.fetchCampaignList()
            })
        })
    },
    handleSearch () {
      this.currentPage = 1
      this.fetchCampaignList()
    },
    handleClearInput () {
      this.currentKeyword = ''
      if (this.keyword !== '') {
        this.handleSearch()
      }
    },
    addNewCampaign () {
      this.$router.push('/campaign/new-campaign-and-brief-v3')
      this.$store.commit('campaign/setId', null)
      this.$store.commit('campaign/setIsBypassCampaign', false)
    },
    addNewShortcutCampaign () {
      this.$router.push('/campaign/new-shortcut')
      this.$store.commit('campaign/setId', null)
    },
    changeBrand (val) {
      this.selectedBrand = val
      this.fetchCampaignList()
    },
    changeVendor (val) {
      this.selectedVendor = val
      this.fetchCampaignList()
    },
    clear () {
      this.selectedVendor = null
      this.selectedBrand = null
      this.fetchCampaignList()
    }
  }
}
</script>

<style lang='stylus'>
.campaign-list__header
  display flex
  justify-content space-between
  .el-button
    display flex
    justify-content space-around
    > span
      display flex
      align-items center

.campaign-list__header__buttons
  display flex
.campaign-list__header__filter
  display flex
  align-items center
  .iconfont
    color $main
    margin-right 24px
.campaign-list__table
  margin-top 20px
  .el-button--mini, .el-button--small
    font-size 14px
  td
    padding-top 15px
    padding-bottom 15px
  .el-table__header-wrapper
    th
      font-size 16px !important
  .el-table__row
    td
      font-size 14px !important
      &:nth-child(6)
        .cell
          text-align left
.campaign-list__pagination
  margin-top 20px
  float right
  .btn-next,.btn-prev
    background none !important
  .el-pager li
    background none

.campaign-list__divider
  margin 0 5px

.addNewProject__btn
  background #4896e6
  box-shadow: 0 0 15px 0 rgba(72, 150, 230, 0.41)
  color #ffffff
  font-weight normal
  width 198px
  height 35px
  font-size 14px
  &.el-button--default
    border none
  &:hover
    background #4896e6 !important
    color #ffffff !important
    border-color #4896e6 !important
.addNewLiteProject__btn
  background #5bd5ac
  box-shadow: 0 0 15px 0 rgba(48, 201, 165, 0.4)
  color #ffffff
  font-weight normal
  width 198px
  height 35px
  font-size 14px
  &.el-button--default
    border none
  &:hover
    background #5bd5ac !important
    color #ffffff !important
    border-color #5bd5ac !important

.campaign-list__operation
  display flex
  align-items center
  .el-button
    padding 5px 13px
    border-radius 2px
    background-color #edf2fa
    border none

.campaign-list
  .el-table
    th
      &:nth-child(1)
        padding-left: 14px
      &:last-child
        padding-right: 14px
    tbody
      tr
        td
          &:nth-child(1)
            padding-left: 14px
          &:last-child
            padding-right: 14px
</style>
